<template>
  <div
    class="backgroundColor"
  >
    <div class="form">
      <div class="headerText">
        <p>
          <img
            src="@/assets/login/header1.png"
            alt=""
          >
        </p>
        <p>
          <img
            src="@/assets/login/header2.jpeg"
            alt=""
          >
        </p>
      </div>
      <login-form />
    </div>
  </div>
</template>
<script>
import { getConfig } from "@/api/user";
import loginForm from "./loginForm";
export default {
  components: {
    loginForm,
  },
  data() {
    return {};
  },
  created() {
  },
  methods: {},
};
</script>
<style lang="less" scoped>
.backgroundColor {
  // 占满整个屏幕
  width: 100%;
  height: 100%;
  // position: fixed;
  background-color: #f0f0f0;
  .form {
    padding: 0px 0 10px 0;
    background-color: #ffffff;
    .headerText {
      padding-top: 10px;
      p {
        text-align: center;
        margin-top: 5%;
        span {
          font-size: 20px;
          color: #1564c3;
        }
        img {
          width: 350px;
          height: 100%;
          border-radius: 5px;
        }
      }
      p:first-child {
        width: 350px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        background-color: #ffffff;
        span {
          font-family: cursive;
          font-size: 25px;
          font-weight: bold;
        }
        img {
          width: 290px;
          height: 100%;
          border-radius: 5px;
        }
      }
    }
  }
}
</style>
